import common from './common';
import tools from './tools'; //工具
import http from './ajax';
import notice from './notice';
let weixin = (function() {
  return {
    default: {
      title: '',
      desc: '',
      href: location.href
    },
    share: function(p) {
      console.log('-----------', p);
      //微信分享
      var param = p ? p : this.default;
      var img = param.logo;
      var imgUrl = img ? img : location.origin + '/apps/public/images/logo.png'; //默认图片
      if (!tools.isWeiXin()) return;
      this.getJssdk(data => {
        var config = {
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: common.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名，见附录1
          jsApiList: [
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'updateTimelineShareData',
            'updateAppMessageShareData',
            'hideAllNonBaseMenuItem',
            'showMenuItems'
          ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          openTagList: ['wx-open-launch-weapp'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
        };
        wx.config(config);
        wx.ready(function() {
          const params = {
            title: param.title,
            desc: param.content,
            link: param.link ? param.link : param.href,
            imgUrl: imgUrl,
            success: function() {
              //layer.msg('分享成功！');
            },
            cancel: function() {
              notice.msg('取消分享！');
            },
            fail: function(res) {
              console.log(JSON.stringify(res));
              // notice.alert(JSON.stringify(res));
            }
          };
          //隐藏所有菜单
          wx.hideAllNonBaseMenuItem();
          wx.showMenuItems({
            menuList: [
              'menuItem:share:appMessage' // 好友分享
            ],
            success: function(res) {},
            fail: function(res) {
              console.log(JSON.stringify(res));
            }
          });
          // 旧版朋友圈
          wx.onMenuShareTimeline(params);
          // 旧版朋友
          wx.onMenuShareAppMessage(params);
          //分享到朋友圈
          wx.updateTimelineShareData(params);
          //分享给朋友
          wx.updateAppMessageShareData(params);
          //alert('已注册获取“发送给朋友”状态事件');
        });
        wx.error(function(res) {
          console.log(res);
        });
      });
    },
    hideMenu() {
      //隐藏微信地址栏自带工具栏
      if (!tools.isWeiXin()) return;
      this.getJssdk(function(data) {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: common.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名，见附录1
          openTagList: ['wx-open-launch-weapp'],
          jsApiList: [
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'updateTimelineShareData',
            'updateAppMessageShareData',
            'hideAllNonBaseMenuItem',
            'showMenuItems'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function() {
          wx.hideAllNonBaseMenuItem();
        });
        wx.error(function(res) {
          console.log(res);
          // alert(JSON.stringify(res));
        });
      });
    },
    //获取地址栏参数
    getQueryStringByName: function(name) {
      var result = location.search.match(new RegExp('[?&]' + name + '=([^&]+)', 'i'));
      if (result == null || result.length < 1) {
        return '';
      }
      return result[1];
    },
    //判断是否存才hash
    hasHash: function() {
      if (window.location.hash && window.location.hash.length > 0) {
        return window.location.hash;
      }
      return '';
    },
    //删除地址栏参数
    delQueStr: function(url, ref) {
      var str = '';
      if (url.indexOf('?') != -1) {
        str = url.substr(url.indexOf('?') + 1);
      } else {
        return url;
      }
      var arr = '';
      var returnurl = '';
      if (str.indexOf('&') != -1) {
        arr = str.split('&');
        for (let i in arr) {
          if (arr[i].split('=')[0] != ref) {
            returnurl = returnurl + arr[i].split('=')[0] + '=' + arr[i].split('=')[1] + '&';
          }
        }
        return url.substr(0, url.indexOf('?')) + '?' + returnurl.substr(0, returnurl.length - 1) + this.hasHash();
      } else {
        arr = str.split('=');
        if (arr[0] == ref) {
          return url.substr(0, url.indexOf('?')) + this.hasHash();
        } else {
          return url;
        }
      }
    },
    //获取微信授权地址
    wechat_redirect_url: function(params) {
      var wxappid = common.appId; //appid
      if (params.appid) {
        wxappid = params.appid;
      }
      var fromurl = '';
      var tempHref = location.href;
      var authText = 'snsapi_userinfo';
      if (params.silent == '1' || params.state == 'snsapi_base') {
        authText = 'snsapi_base';
      } else {
        authText = 'snsapi_userinfo';
      }
      tempHref = this.delQueStr(tempHref, 'code');
      tempHref = this.delQueStr(tempHref, 'state');
      //如果当前访问域名不在安全域名内,则跳转到个人中心的登录跳转页
      fromurl = encodeURIComponent(tempHref);
      if (sessionStorage.openAuth) {
        sessionStorage.openAuth = sessionStorage.openAuth * 1 + 1;
      } else {
        sessionStorage.openAuth = '1';
      }
      const commponentAppid = common.commponentAppid;
      let url = '';
      if (params.authType == 'platform') {
        url =
          'https://open.weixin.qq.com/connect/oauth2/authorize?component_appid=' +
          commponentAppid +
          '&appid=' +
          wxappid +
          '&redirect_uri=' +
          fromurl +
          '&response_type=code&scope=' +
          authText +
          '&state=' +
          authText +
          '&connect_redirect=1#wechat_redirect';
      } else {
        url =
          'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
          wxappid +
          '&redirect_uri=' +
          fromurl +
          '&response_type=code&scope=' +
          authText +
          '&state=' +
          authText +
          '&connect_redirect=1#wechat_redirect';
      }
      console.log(url);
      return url;
    },
    /**
     * 跳转微信授权
     * @param {*} params.wxLogin 是否是登录授权 默认false
     * @param {*} params.authType 授权类型 wechat:公众号授权 platform:平台授权
     * @param {*} params.state 授权信息 snsapi_base:基础信息 snsapi_userinfo:用户信息
     */
    jumpAuth(params = {}) {
      const defParams = {
        wxLogin: false,
        authType: 'platform',
        state: 'snsapi_userinfo',
      }
      params = Object.assign(defParams, params);
      let url = window.location.href;
      let addStr = "&";
      if (url.indexOf("?") < 0) {
        addStr = "?";
      }
      if (url.indexOf("forceAuth") < 0) url += `${addStr}forceAuth=1`;
      url = this.delQueStr(url, 'code');
      url = this.delQueStr(url, 'state');
      sessionStorage.wxAuthParams = JSON.stringify(params);// 保存授权参数
      window.location.replace(url);
    },
    // 公用授权处理
    forceAuth(callback) {
      const forceAuth = this.getQueryStringByName('forceAuth');// 是否需要授权
      if (!forceAuth) {
        // 未开启授权，不处理
        callback && callback({});
        return;
      }
      const params = JSON.parse(sessionStorage.wxAuthParams);// 获取授权参数
      if (localStorage.fqjd_kh && !params.wxLogin) {
        callback && callback({});
        return;
      }
      this.wxmplogin(params, callback);
    },
    // 授权完成后用于页面获取微信信息
    getWxinfo(callback) {
      let userInfo = {};
      if (localStorage.fqjd_kh) {
        try {
          userInfo = JSON.parse(localStorage.fqjd_kh);
        } catch (e) {
          console.log('读取本地微信用户信息失败', e);
        }
        if (userInfo.hasOwnProperty('nickName')) {
          callback && callback(userInfo);
        }
      } else if (localStorage.jzy_openid) {
        try {
          userInfo.openid = localStorage.jzy_openid;
        } catch (e) {
          console.log('读取本地微信用户信息失败', e);
        }
        if (userInfo.hasOwnProperty('openid')) {
          callback && callback(userInfo);
        }
      }
      return userInfo;
    },
    /**
     * 微信授权
     * @param {*} params.wxLogin 是否是登录授权 默认false
     * @param {*} params.authType 授权类型 wechat:公众号授权 platform:平台授权
     * @param {*} params.state 授权信息 snsapi_base:基础信息 snsapi_userinfo:用户信息
     * @param {*} callback 
     * @returns 
     */
    wxmplogin(params = {}, callback) {
      // 公众号授权
      if (params.authType == 'wechat') {
        this.login(params, callback)
        return
      }
      // 第三方平台授权
      const orgId = this.getQueryStringByName('orgId') || localStorage.orgId || '';
      if (!orgId) {
        callback && callback();
        return;
      }
      localStorage.orgId = orgId;
      http({
        url: '/api/user/getAppid',
        type: 'GET',
        hideAlert: true,
        data: {
          orgId: orgId
        }
      }).then((result, er) => {
        if (result.httpCode != 1) {
          callback && callback();
          return;
        }
        if (result.data) {
          params.appid = result.data;
        }
        this.login(params, callback);
      });
    },
    login: function(params = {}, callback, flag) {
      console.log('login', params);
      if (flag) {
        if (localStorage.jzy_user) {
          callback && callback(localStorage.jzy_user);
          return;
        }
      } else {
        if (localStorage.jzy_openid && !params.requestUrl) {
          callback && callback(localStorage.jzy_openid);
          return;
        }
      }

      const code = this.getQueryStringByName('code');
      const state = this.getQueryStringByName('state');
      const appid = params.appid ? params.appid : common.appId;
      if (!code) {
        const redirect_url = this.wechat_redirect_url({ ...params, appid }); //获取授权地址
        window.location.replace(redirect_url);
      } else {
        let url = '';
        if (params.requestUrl) {
          url = params.requestUrl;
        } else if(params.authType == 'platform') {
          // 第三方平台授权
          url = '/api/user/loginByAuth2';
        } else if(params.authType == 'snsapi_base') {
          // 公众号基础授权
          url = '/insure/getOpenid';
        } else {
          // 公众号授权
          url = '/api/user/loginByAuth';
        }
        http({
          url: url,
          type: 'GET',
          hideAlert: true,
          data: {
            orgId: localStorage.orgId || '',
            code: code,
            state: state,
            appid: appid
          }
        }).then((result, er) => {
          const data = result.data;
          // 异常处理
          if (result.httpCode != 1 || !data) {
            // 登录授权
            if(data && data.wechatId) {
              localStorage.setItem('wechatId', data.wechatId);
              callback && callback('');
              return;
            }
            if (sessionStorage.openAuth > 2) {
              sessionStorage.ignoreAuth = '1';
              sessionStorage.openAuth = '';
              callback && callback('');
              return;
            }
            var redirect_url = this.wechat_redirect_url(params);//获取授权地址
            window.location.replace(redirect_url);
            return;
          }
          // 成功处理
          if (typeof data == 'string') {
            localStorage.setItem('jzy_openid', data);
            callback && callback({ openid: data });
          } else if (data && data.openid) {
            sessionStorage.ignoreAuth = '1';
            sessionStorage.openAuth = '';
            // 客户授权
            localStorage.fqjd_kh = JSON.stringify(data);
            callback && callback(data);
          } else if(data) {
            sessionStorage.ignoreAuth = '1';
            sessionStorage.openAuth = '';
            // 登录授权
            if(data.wechatId) {
              localStorage.setItem('wechatId', data.wechatId);
            }
            if(data.token) {
              localStorage.jzy_token = data.token;
              localStorage.jzy_user = JSON.stringify(data);
              if(localStorage.orgId) {
                localStorage['token' + localStorage.orgId] = data.token;
                localStorage['user' + localStorage.orgId] = JSON.stringify(data);
              }
            }
            callback && callback(data);
          } else {
            sessionStorage.ignoreAuth = '1';
            sessionStorage.openAuth = '';
          }
        });
      }
    },
    getJssdk: function(callback) {
      // alert(location.href.split('#')[0])
      var url = location.href.split('#')[0];
      if (tools.isIOS() && window.entryUrl) {
        url = window.entryUrl;
      }
      http({
        url: '/api/user/wechat/share',
        type: 'POST',
        data: {
          appid: common.appId,
          url: url
        }
      }).then((r, er) => {
        console.log(r);
        callback(r.data);
      });
    }
  };
})();

export default weixin;
